import { toast } from 'react-toastify';

// Debounce timer to prevent multiple success toasts in quick succession
let debounceTimer: ReturnType<typeof setTimeout> | null = null;

export const handleSuccess = (message: string, delay: number = 300): void => {
  // Clear any existing timer
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }

  // Set a new timer
  debounceTimer = setTimeout(() => {
    toast.success(message);
    debounceTimer = null;
  }, delay);
};
